const namespaced = true;
const state = {
  searchFilter: null
};
const mutations = {
  SET_SEARCH_FILTER(state, payload) {
    state.searchFilter = payload;
  }
  //  SET_YEAR_MONTH(state, payload) {
  //    state.searchFilter.yearMonth = payload;
  //  },
};
const actions = {
  async setSearchFilter({ commit }, value) {
    commit('SET_SEARCH_FILTER', value);
  }
  //  async setYearMonth({ commit }, { year, month }) {
  //    commit('SET_YEAR_MONTH', ${year}-${month});
  //  },
};
const getters = {
  getSearchFilter: state => {
    return state.searchFilter;
  }
};
export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
